var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Title',{class:_vm.$style.title,attrs:{"id":_vm.titleId,"title-params":_vm.primary.text,"data-luko-tracking":"SecondTitle"}})}
var staticRenderFns = []

export { render, staticRenderFns }